 "use strict";
 /**
  * trsHight Module
  *
  * Description
  */
 angular.module('trsHeightModule', []).directive('trsHeight', ['$window', '$parse', '$timeout', function($window, $parse, $timeout) {

     return {
         restrict: 'EA',
         link: function(scope, iElement, iAttrs) {
             function contentHeigth() {
                 $(".content_text_wrap").height($(window).height() - ($(".content_text_label").outerHeight(true) + $(".view_head").outerHeight(true)+15));
             }
             $timeout(function() {
                 contentHeigth();
             });
             $(".content_text_label,body").resize(function(event) {
                 contentHeigth();
             });
             $(window).resize(function(event) {
                 contentHeigth();
             });
         }
     };
 }]);